//apps\web\src\services\api.js
import axios from "axios";
import { AUTH_TOKEN } from "constants/AuthConstant";
import { API_BASE_URL } from "configs/AppConfig";

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem(AUTH_TOKEN) || localStorage.getItem("token");

    config.headers = config.headers || {};

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default api;